export default "<span>\n    <ng-transclude></ng-transclude>\n</span>";